'use server';

import { redirect } from 'next/navigation';
import { prisma } from '@/lib/prisma';
import { abrirSessao, conferirSenha, hashSenha } from '@/lib/auth';

export type EstadoFormulario = { erro?: string } | undefined;

function normalizarEmail(valor: unknown) {
  return String(valor ?? '').trim().toLowerCase();
}

export async function entrar(_estado: EstadoFormulario, dados: FormData): Promise<EstadoFormulario> {
  const email = normalizarEmail(dados.get('email'));
  const senha = String(dados.get('senha') ?? '');

  if (!email || !senha) return { erro: 'Informe e-mail e senha.' };

  const user = await prisma.user.findUnique({ where: { email } });
  // Mensagem única para e-mail inexistente e senha errada: dizer qual dos dois
  // falhou entregaria a lista de quem tem conta aqui.
  if (!user || !(await conferirSenha(senha, user.passwordHash))) {
    return { erro: 'E-mail ou senha incorretos.' };
  }

  await prisma.user.update({ where: { id: user.id }, data: { lastLoginAt: new Date() } });
  await abrirSessao(user.id);
  redirect(user.isApproved ? '/painel' : '/aguardando');
}

export async function cadastrar(_estado: EstadoFormulario, dados: FormData): Promise<EstadoFormulario> {
  const nome = String(dados.get('nome') ?? '').trim();
  const email = normalizarEmail(dados.get('email'));
  const senha = String(dados.get('senha') ?? '');

  if (!nome || !email || !senha) return { erro: 'Preencha todos os campos.' };
  if (senha.length < 8) return { erro: 'A senha precisa ter pelo menos 8 caracteres.' };
  if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) return { erro: 'E-mail inválido.' };

  const existente = await prisma.user.findUnique({ where: { email } });
  if (existente) return { erro: 'Já existe uma conta com este e-mail.' };

  const user = await prisma.user.create({
    data: { name: nome, email, passwordHash: await hashSenha(senha) }
  });

  await abrirSessao(user.id);
  redirect('/aguardando');
}
